import { memo } from "react";
import cx from "classnames";
import PaymentDrawTonightInterfaceStore from "../../interface/PaymentDrawTonightInterface";
import Details from "./Details";
import GiveawayCard from "./GiveawayCard";
import s from "./PaymentDrawTonightContent.module.scss";

const PaymentDrawTonightContent: React.FC = (): JSX.Element => {
  const isMobile = PaymentDrawTonightInterfaceStore((state) => state.isMobile);

  return (
    <div
      className={cx(s.container, {
        [s.containerMobile]: isMobile,
      })}
    >
      <Details />
      <GiveawayCard />
    </div>
  );
};

export default memo(PaymentDrawTonightContent);
